import { render, staticRenderFns } from "./BoardCreate.vue?vue&type=template&id=c329521e&scoped=true"
import script from "./BoardCreate.vue?vue&type=script&lang=js"
export * from "./BoardCreate.vue?vue&type=script&lang=js"
import style0 from "./BoardCreate.vue?vue&type=style&index=0&id=c329521e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c329521e",
  null
  
)

export default component.exports